import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axiosInstance from "./axiosInstance";


const CheckpointAddModal = ({ show, handleClose, raceId, onCheckpointAdded }) => {
    const [checkpointName, setCheckpointName] = useState("");
    const [formErrors, setFormErrors] = useState({});

    const [readers, setReaders] = useState([]);
    const [selectedReaderId, setSelectedReaderId] = useState("");

    useEffect(() => {
        axiosInstance.get("/readers/")
            .then(res => setReaders(res.data))
            .catch(err => console.log(err));
    }, []);

    // useEffect(() => {
    //     if (checkpoint?.reader) {
    //         setSelectedReaderId(checkpoint.reader.id);
    //     } else {
    //         setSelectedReaderId("");
    //     }
    // }, [checkpoint]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!checkpointName.trim()) {
            setFormErrors({ name: "Name is required" });
            return;
        }

        axiosInstance.post(`/checkpoints/`, { name: checkpointName, race: raceId })
            .then(response => {
                onCheckpointAdded(response.data); // renvoyer le nouveau checkpoint au parent
                setCheckpointName("");
                setFormErrors({});
                handleClose();
            })
            .catch(error => {
                setFormErrors(error.response?.data || { general: "Erreur serveur" });
            });
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Form onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Checkpoint</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {formErrors.general && <p className="text-danger">{formErrors.general}</p>}
                    <Form.Group>
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Checkpoint name"
                            value={checkpointName}
                            onChange={(e) => setCheckpointName(e.target.value)}
                            isInvalid={!!formErrors.name}
                        />
                        <Form.Control.Feedback type="invalid">
                            {formErrors.name}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                    <Button type="submit" variant="primary">Add</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default CheckpointAddModal;
